import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Amplify, Auth } from 'aws-amplify';
import { User } from 'projects/shared/src/interfaces/interfaces';
import listRedirectFlow from 'projects/shared/src/JSON/redirectsFlows.json';
import CryptoJS from 'crypto-js';
import { FrameInControl } from 'projects/shared/src/interfaces/frame-in-control.interface';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  ipAddress: string = '';
  protected cognmito: any;

  constructor(private router: Router) {}

  setCognito(cognito: any) {
    this.cognmito = cognito;
    Amplify.configure({
      Auth: cognito,
    });
  }

  getIdSessionHAsh(token: string) {
    return CryptoJS.HmacMD5(token, 'token').toString();
  }

  /**
   * Get user information
   *
   * @returns
   */
  public getUser(): Promise<any> {
    return Auth.currentUserInfo();
  }

  /**
   * Get current user's session
   *
   * @returns
   */
  public currentUserCredentials(): Promise<any> {
    return Auth.currentSession();
  }

  /**
   * Update an authenticated users' attributes
   *
   * @param user
   * @returns
   */
  public updateUser(user: User): Promise<any> {
    return Auth.currentUserPoolUser().then((cognitoUser: any) => {
      return Auth.updateUserAttributes(cognitoUser, user);
    });
  }
  /**
   * Sign-out
   *
   * @returns
   */
  public signOut(): Promise<any> {
    return Auth.signOut().then(() => {
      return Promise.resolve(false);
    });
  }

  getMaxLengthDocument(type: string) {
    if (type == 'CED') {
      return 10;
    } else if (type == 'RUC') {
      return 13;
    } else if (type == 'PAS') {
      return 15;
    }
    return 0;
  }

  //
  searchDetailTrackingMod(details: any, userId: string, operation: string) {
    for (let detail of details) {
      if (
        detail.operationId === operation &&
        detail.userId.toUpperCase() === userId.toLocaleUpperCase()
      ) {
        detail.operationStatus = 'COMPLETED';
        return detail;
      }
    }
    return;
  }

  searchRedirectFlow(idRedirect: string) {
    for (let redirect of listRedirectFlow) {
      if (redirect.id === idRedirect) {
        return redirect.redirect;
      }
    }

    return 'dashboard';
  }

  searchEmail(list: any) {
    for (let mail of list) {
      if (mail.principal == 'true') {
        return mail.address;
      }
    }
  }

  searchPhone(list: any) {
    for (let phone of list) {
      if (phone.principal == 'true') {
        return phone.number;
      }
    }
  }

  searchScreen(list: any) {
    for (let item of list) {
      if (item.flowUser == 'SELLER') {
        return item.screenId;
      }
    }
    return '';
  }

  searchStepLogiFlow(list: any) {
    for (let item of list) {
      if (
        item.flowUser == 'LOGIFLOW' &&
        item.operationStatus === 'ACTIVE' &&
        item.stepId === 'LOANVALIDATION'
      ) {
        return item.stepId;
      }
    }
    return '';
  }

  searchScreenCompleted(list: any) {
    for (let item of list) {
      if (item.flowUser == 'SELLER' && item.operationStatus == 'COMPLETED') {
        return true;
      }
    }
    return false;
  }

  searchStep(idScreen: string) {
    for (let redirect of listRedirectFlow) {
      if (redirect.id === idScreen) {
        return redirect.step;
      }
    }

    return '';
  }

  searchNationality(pNationality: string) {
    if (
      pNationality &&
      ('ECUATORIANA' === pNationality.toUpperCase() ||
        'ECUATORIANO' === pNationality.toUpperCase() ||
        'ECU' == pNationality.toUpperCase())
    ) {
      return 'ECUATORIANA';
    } else if (pNationality === '') {
      return '';
    }
    return 'EXTRANJERA';
  }

  // search by name, and the answer is the object it found,
  // otherwise it returns an object with a default ID that it receives as a parameter
  searchDefault(name: string, listDefault: any, returnDefault: any) {
    for (let item of listDefault) {
      if (item.name === name) {
        return item;
      }
    }

    return { id: returnDefault };
  }

  buildDataSimulation(loanValues: any, loanParameters: any) {
    return {
      brandVehicle: loanValues.BRAND,
      modelVehicle: loanValues.MODEL,
      yearVehicle: loanParameters.YEAR,
      costVehicle: loanParameters.INITIAL_VALUE,
      inputValue: loanParameters.ENTRY_PAYMENT_VALUE,
      timeCredit: loanParameters.CREDIT_TERM,
      worthDeviceTracing: loanValues.TRACKING_DEVICE_VALUE,
      payDay: loanParameters.PAYMENT_DATE,
      accessories: loanValues.ACCESSORIES,
      disbursementDate: loanParameters.DISBURSEMENT_DATE,
      cityDealer: loanParameters.CITY,
      provinceDealer: loanParameters.PROVINCE,
      mileage: loanParameters.MILEAGE || 0,
      idPartnerDealer: loanParameters.ID_PARTNER_DEALER || '',
      partnerDealerName: loanParameters.PARTNER_DEALER_NAME || '',
      idInsuranceVehicle: loanParameters.ID_INSURANCE_VEHICLE || '',
      insuranceVehicleName: loanParameters.INSURANCE_VEHICLE || '',
      loanValue: loanParameters.LOAN_VALUE,
      loanValueInitial: loanParameters.LOAN_VALUE_INITIAL,
    };
  }

  buildDataSemaphore(loanValues: any, loanParameters: any) {
    return {
      brandVehicle: loanValues.BRAND,
      modelVehicle: loanValues.MODEL,
      yearVehicle: loanParameters.YEAR,
      costVehicle: loanParameters.INITIAL_VALUE,
      inputValue: loanParameters.ENTRY_PAYMENT_VALUE,
      timeCredit: loanParameters.CREDIT_TERM,
      worthDeviceTracing: loanValues.TRACKING_DEVICE_VALUE,
      payDay: loanParameters.PAYMENT_DATE,
      accessories: loanValues.ACCESSORIES,
      disbursementDate: loanParameters.DISBURSEMENT_DATE,
      cityDealer: loanParameters.CITY,
      provinceDealer: loanParameters.PROVINCE,
      mileage: loanParameters.MILEAGE || 0,
      idPartnerDealer: loanParameters.ID_PARTNER_DEALER || '',
      partnerDealerName: loanParameters.PARTNER_DEALER_NAME || '',
      idInsuranceVehicle: loanParameters.ID_INSURANCE_VEHICLE || '',
      insuranceVehicleName: loanParameters.INSURANCE_VEHICLE || '',
      loanValue: loanParameters.LOAN_VALUE,
      loanValueInitial: loanParameters.LOAN_VALUE_INITIAL,
    };
  }

  setFrameIn(pUserToken: any, pUserLogin: any, pData: any) {
    let frameIn: any = {};
    frameIn.session = pUserToken.accessToken;
    frameIn.userapp = pUserLogin.attributes.email;
    frameIn.channel = 'AWS';
    frameIn.operation = pData.operation;
    frameIn.process = pData.idProcess;

    let frameInControls: Array<FrameInControl> = [];
    let frameInControl: FrameInControl = {} as FrameInControl;

    frameInControl.data = pData.data;
    frameInControl.extras = pData.extras;
    frameInControls.push(frameInControl);
    frameIn.control = frameInControls;

    return frameIn;
  }

  convertDataBoolean(list: any) {
    for (let item of list) {
      for (let attribute in item) {
        if (item[attribute] === 'true' || item[attribute] === 'false') {
          if (item[attribute] === 'true') {
            item[attribute] = true;
          } else {
            item[attribute] = false;
          }
        }
      }
    }

    return list;
  }

  convertListToUppercase(list: any) {
    for (let item of list) {
      for (let attribute in item) {
        item[attribute] = item[attribute].toString().toUpperCase();
      }
    }

    return list;
  }
}
